import { GlobalSearchPath } from './../../../../modules/shared/constants/global-search-path';
import { SharedChannelService } from './../../../../modules/shared/services/channel.service';
import { CaseModuleId, OpportunityModuleId } from './../../../../modules/shared/constants/modules.constant';
import { PermissionService } from 'src/app/service/permission.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AccountOpportunityService } from 'src/app/accounts-v2/services/account-opportunity.service';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
// import { CasesService } from 'src/app/cases/cases.service';
import { CasesService } from 'src/app/cases-v2/services/cases.service';
import { ChannelN } from 'src/app/modules/shared/models/channel.model';
import { ObjectNames } from 'src/app/shared/constants';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { Status } from 'src/app/models/statusEnums';
import { OpportunitiesService } from 'src/app/opportunities-v2/services/opportunity.service';
import { StageN } from 'src/app/accounts-v2/models/stage.model';
import { CrmSharedConfigurationService } from 'src/app/configurations/crm/shared/components/crm-shared-configuration/services/crm-shared-configuration.service';

@Component({
    selector: 'app-account-detail-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss']
})
export class AccountDetailTableComponent implements OnInit, OnDestroy {

    @Input() module;
    @Input() filteredAccount;
    @Input() selectedAccountChannel: ChannelN;

    private ngUnsubscribe$ = new Subject<void>();

    dataList: any[] = [];
    selectedData: any;
    displayAddEditView: boolean = false;
    paths = GlobalSearchPath;

    //Add/Edit Cases/Opportunty
    crudType: 'add'|'update'|'view' = 'add';
    viewEditcaseId: number = 0;
    opportunityEditViewId: number = 0;
    opportunityChannelId: number = 0;
    caseChannelId: number = 0;

    /* Permission */
    readPermission: boolean;
    writePermission: boolean;
    editPermission: boolean;
    deletePermission: boolean;
    groupUserList:any[] = [];
    opportunityChannelList:any[] = [];
    casesChannelList:any[] = [];
    // stage change comment Popup
    selectedOpportunityComment;
    closedStages: any[] = [];
    commentHeaderName;
    displayCommentAdd = false;
    tempComment: any;
    commentDefault = {
        id: 0,
        createdSource: this.app.user.userIP,
        updatedSource: this.app.user.userIP,
        createdBy: this.app.user.userId,
        updatedBy: this.app.user.userId,
        createdDate: new Date(),
        updatedDate: new Date(),
        organizationId: this.app.user.organizationId,
        objectRecordId: '',
        objectId: this.app.preLoadedObjects.find(obj => obj.name == ObjectNames.OPPORTUNITY)?.id,
        comment: '',
        isPublic: true,
        stageId: 0,
        statusId: Status.Active,
    };
    allStages: any[] = [];
    selectedOpportunityDetail: any;
    selectedView: string;
    nextStageIdForUpdate: number;
    commentFormType: string;
    stagesCountN: StageN[] = [];
    selectedStageId: number;
    objectType: string;
    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();
    constructor(
        private router: Router,
        private caseService: CasesService,
        private appMainService: AppMainService,
        public app: AppMainComponent,
        private messageService: MessageService,
        private accountServiceN: AccountServiceN,
        private accOpportunityService: AccountOpportunityService,
        private confirmationService: ConfirmationService,
        private permissionService: PermissionService,
        private sharedChannelService: SharedChannelService,
        private opportunityService: OpportunitiesService,
        private sharedConfigService: CrmSharedConfigurationService,
    ) { }

    ngOnInit(): void {
        this.setPermissions();
        switch (this.module) {
            case 'Case':
                this.getCasesChannels();
                this.getAccountCasesList();
                this.getUserGroupList();
                break;
            case 'Opportunity':
                this.getOpportunityChannels();
                this.getAccountOpportunityList();
                break;
            default:
                break;
        }
    }

    getUserGroupList() {
        this.accOpportunityService.getUserGroups(this.app.user.organizationId).subscribe(
          (groupUserList) => {
            this.groupUserList = groupUserList;
          },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while fetching user groups...' });
          }
        );
      }

    setPermissions(): void {
        const userPermissions = this.permissionService.getPermissionData();
        let objectName = ObjectNames.ACCOUNT;

        switch (this.module) {
            case 'Case':
                objectName = ObjectNames.CASES;
                break;
            case 'Opportunity':
                objectName = ObjectNames.OPPORTUNITY;
                break;
            default:
                break;
        }

        if (userPermissions.length) {
            let modulePermission = userPermissions.find(obj => obj.objectName === objectName);
            modulePermission = modulePermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);

            this.readPermission = modulePermission && (modulePermission[0].permissionId == 1 && modulePermission[0].statusId == 1);
            this.writePermission = modulePermission && (modulePermission[1].permissionId == 2 && modulePermission[1].statusId == 1);
            this.editPermission = modulePermission && (modulePermission[2].permissionId == 3 && modulePermission[2].statusId == 1);
            this.deletePermission = modulePermission && (modulePermission[3].permissionId == 4 && modulePermission[3].statusId == 1);
        }
    }

    showAddPopup() {
        this.viewEditcaseId = 0;
        this.opportunityEditViewId = 0;
        this.crudType = 'add';
        this.displayAddEditView = true;
    }

    openViewEdit(rowData: any, type: 'view'|'update'){
        this.viewEditcaseId = rowData.id;
        this.opportunityEditViewId = rowData.id;
        this.crudType = type;
        this.displayAddEditView = true;
        if (this.module == 'Opportunity') {
            this.opportunityChannelId = rowData?.channelId;
        } else {
            this.caseChannelId = rowData?.channelId;
        }
    }

    closeDialog(){
        this.displayAddEditView = false;
        this.viewEditcaseId = 0;
        this.opportunityEditViewId = 0;
    }

    onRowSelect(e) {

    }

    getOpportunityChannels(): void {
        this.appMainService.isShowSpinner('getChannel');
        this.sharedChannelService.getAllChannels(OpportunityModuleId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                const channels = response || [];
                this.opportunityChannelList = response;
                const selectedPipeline = channels?.length>0 ? channels.find(el => el.isDefault == true) || channels[0] : null;
                this.opportunityChannelId = selectedPipeline?.id||0;
                this.getChannelStage(this.opportunityChannelId,null);
                this.getChannelStageDetails(3, this.opportunityChannelId);
                this.appMainService.isHideSpinner('getChannel');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getChannel');
            }
        });
    }

    getCasesChannels(): void {
        this.appMainService.isShowSpinner('getChannel');
        this.sharedChannelService.getAllChannels(CaseModuleId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                const channels = response || [];
                this.casesChannelList = response;
                const selectedPipeline = channels?.length>0 ? channels.find(el => el.isDefault == true) || channels[0] : null;
                this.caseChannelId = selectedPipeline?.id||0;
                this.getChannelStage(this.caseChannelId,null);
                this.getChannelStageDetails(8, this.caseChannelId);
                this.appMainService.isHideSpinner('getChannel');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getChannel');
            }
        });
    }

    updateParentOpportunity($event) {
        this.getAccountOpportunityList();
    }


    getAccountOpportunityList() {
        this.appMainService.isShowSpinner('getAccountOpportunityList');
        this.accountServiceN.getAccountOpportunityList(this.filteredAccount?.id).subscribe({
            next: (data) => {
                this.dataList = data;
                this.appMainService.isHideSpinner('getAccountOpportunityList');
            }
        })
    }

    updateParentCases(event) {
        this.getAccountCasesList();
    }

    getAccountCasesList() {
        this.appMainService.isShowSpinner('getAccountCasesList');
        this.accountServiceN.getAccountCasesList(this.filteredAccount?.id).subscribe({
            next: (data) => {
                this.dataList = this.formatGroupData(data||[]);
                this.appMainService.isHideSpinner('getAccountCasesList');
            }
        })
    }

    formatGroupData(caseGroups: any[]){
        const groupList = [];

        caseGroups.map(group=>{
            const existIndex = groupList.findIndex(l=> l.id==group.id && l.name==group.name);
            if(existIndex>=0){
                groupList[existIndex].numberOfTickets += group.numberOfTickets;
                groupList[existIndex].tickets = [...groupList[existIndex].tickets,...group.tickets];
            }else{
                groupList.push(group);
            }
        });

        return groupList;
    }

    deleteData(rowData: any) {
        if (this.module == 'Opportunity') {
            this.confirmationService.confirm({
                message: 'Are you sure that you want to delete this opportunity?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.accOpportunityService.deleteOpportunity(rowData.id).then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                        this.getAccountOpportunityList();
                    }).catch(() => {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
                    });

                }
            });
        } else {
            this.confirmationService.confirm({
                message: 'Are you sure that you want to delete this case?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.caseService.deleteCase(rowData.id).subscribe(
                        () => {
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                            this.getAccountCasesList();
                        },
                        err => this.messageService.add({ severity: 'error', summary: 'Error', detail: err.Message })
                    );

                }
            });
        }
    }

    moduleNavigation(data: any) {
		let url = "";
		let queryParams = {
			id: data.id,
			channelId: data?.typeId,
			module: "",
			statusId: data?.statusId || 1,
			globalSearch: true,
			data: "",
		};

        switch(this.module){
            case 'Opportunity':
                url = this.paths.Opportunity;
                queryParams.data = data.name;
			    queryParams.module = 'Opportunity';
                break;
            case 'Case':
                url = this.paths.Case;
                queryParams.data = data.associationName;
			    queryParams.module = 'Case';
                break;
            default:
                break
        }

		this.router.navigate([url], {
            queryParams
        })
	}

    openStagePopUp(data,index:number){
        if (this.module == 'Opportunity') {
            this.objectType = 'Opportunity';
            this.selectedOpportunityDetail = JSON.parse(JSON.stringify(data));
            this.selectedOpportunityDetail.opportunityStageId = this.dataList[index]?.id;
            this.selectedStageId = this.selectedOpportunityDetail.opportunityStageId;
            this.nextStageIdForUpdate = this.selectedOpportunityDetail.opportunityStageId;
            this.opportunityChannelId = data?.channelId;
            this.getChannelStage(this.opportunityChannelId,data);
            // this.openUpdateStagePopup(data);
        }else if(this.module == 'Case'){
            this.objectType = 'Case';
            this.selectedOpportunityDetail = JSON.parse(JSON.stringify(data));
            this.selectedOpportunityDetail.ticketStageId = this.dataList[index]?.id;
            this.selectedStageId = this.selectedOpportunityDetail.ticketStageId;
            this.nextStageIdForUpdate = this.selectedOpportunityDetail.ticketStageId;
            this.caseChannelId = data?.channelId;
            this.getChannelStage(this.caseChannelId,data);
            // this.openUpdateStagePopup(data);
        }
    }

    openUpdateStagePopup(data:any) {
        if (this.editPermission) {
            let object;
            if (this.selectedOpportunityDetail) {
                object = this.selectedOpportunityDetail;
                this.selectedOpportunityDetail = { ...this.selectedOpportunityDetail, closedStages: this.closedStages, callFromAccounts: true };
            }
            this.app.objectId = object ? object.id : 0;
            this.app.objectType = this.module == 'Opportunity' ? ObjectNames.OPPORTUNITY : ObjectNames.CASES;
            // this.nextStageIdForUpdate = data.id;
            this.commentHeaderName = this.module == 'Opportunity' ? `Opportunity Name : ${object ? object.name : ''}` : `Case No : ${object ? object.sequenceNumber : ''}`;

            if (data.id == -1 && this.closedStages.find(x => x.id == this.selectedStageId) || this.selectedStageId == data.id) {
                this.appMainService.isShowSpinner('getLeadStageReasonComment');
                this.opportunityService.getLeadStageReasonComment(this.app.user.organizationId, this.app.user.userId, object.id, this.selectedStageId).then((responseData) => {
                    this.appMainService.isHideSpinner('getLeadStageReasonComment');
                    if (responseData && responseData.stageId) {
                        this.displayCommentAdd = true;
                        this.tempComment = responseData;
                        this.commentFormType = 'View';
                    } else {
                        this.displayCommentAdd = true;
                        this.tempComment = this.commentDefault;
                        this.commentFormType = 'Add';
                    }
                    // this.module == 'Opportunity' ? this.getChannelStage(this.opportunityChannelId) : this.getChannelStage(this.caseChannelId);
                },
                    err => {
                        this.appMainService.isHideSpinner('getLeadStageReasonComment');
                        this.displayCommentAdd = true;
                        this.tempComment = this.commentDefault;
                        this.commentFormType = 'Add';
                    });
            } else {
                this.displayCommentAdd = true;
                this.tempComment = this.commentDefault;
                this.commentFormType = 'Add';
            }
        }
    }

    getChannelStage(channelId, data): void {
        this.appMainService.isShowSpinner('getStages');
        let requestBody: {
            accountChannelId: number,
            channelId: number,
            isActive: boolean,
            Filter: string | null,
        } = {
            accountChannelId: this.selectedAccountChannel?.id,
            channelId: channelId,
            isActive: true,
            Filter: null
        }
        if(this.module == 'Opportunity'){
            this.opportunityService.getStages(requestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response: any) => {
                    this.stagesCountN = response || [];
                    if(data){
                        this.openUpdateStagePopup(data);
                    }
                    this.appMainService.isHideSpinner('getStages');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getStages');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Stages are not loaded, please try again...'
                    });

                }
            });
        }else{
            this.caseService.getStages(requestBody)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
              next: (response: any) => {
                this.stagesCountN = response || [];
                if(data){
                    this.openUpdateStagePopup(data);
                }
                this.appMainService.isHideSpinner('getStages');
              },
              error: (error) => {
                this.appMainService.isHideSpinner('getStages');
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: error?.error?.message ? error?.error?.Message : 'Stages are not loaded, please try again...'
                });

              }
            });
        }
    }

    getChannelStageDetails(moduleId, channelId): void {
        this.appMainService.isShowSpinner('getChannelStageDetails');
        this.sharedConfigService.getChannelStages(moduleId, channelId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                {
                    next: (response) => {
                        this.allStages = response;
                        this.closedStages = response.filter(x => x?.probability == 0 || x?.probability == 100) || [];
                        this.appMainService.isHideSpinner('getChannelStageDetails');
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getChannelStageDetails');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.Message : 'Stages are not loaded, please try again...'
                        });
                    },
                    complete: () => { },

                });
    }

    onCommentSaved(event) {
        if(this.module == 'Opportunity'){
            this.getAccountOpportunityList();
        }else{
            this.getAccountCasesList();
        }
        this.displayCommentAdd = false;
        this.selectedOpportunityDetail = null;
    }


    onCancelComment(event) {
        this.displayCommentAdd = false;
        this.selectedOpportunityDetail = null;
    }

    onCommentDelete(event) {
        this.displayCommentAdd = false;
        this.selectedOpportunityDetail = null;
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
